import { Box } from '@chakra-ui/react';
import React from 'react';

interface DividerProps {
  customPadding?: boolean;
  className?: string;
}

const Divider = ({
  customPadding = false,
  className = '',
}: DividerProps): React.ReactElement => {
  if (customPadding) {
    return (
      <Box px="0px" m="0px" mb="0px" className={className}>
        <Box
          backgroundColor="brand.titleHighlight"
          height="0.5px"
          marginTop="30px"
          marginBottom="10px"
        />
      </Box>
    );
  }
  return (
    <Box px="0px" m="0px" mb="0px" className={className}>
      <Box
        backgroundColor="brand.titleHighlight"
        height="0.5px"
        px="20"
        my="30px"
      />
    </Box>
  );
};

export default Divider;
